'use strict';

export default class Text {
  constructor() {

    $(document).ready(function(){
      $('table:not(.rdTable):not(.rwTable)').wrap("<div class='table'></div>");
        let $eventText = $('.js-text--event-detail-rte');
        let $eventTextTitleRepeated = $('.js-text--event-detail-rte p:first-child');
        if($eventText.length) {
          let $eventTextChildren = $('.js-text--event-detail-rte *');

          //remove inline style attributes
          $eventTextChildren.removeAttr("style");

          //remove first p tag as it repeats the title
          // $eventTextTitleRepeated.remove();

          //remove br tags in p tags which add extra spacing
          let eventDetailHtml = $('.js-text--event-detail-rte').html();
          let cleanedEventDetailHtml = eventDetailHtml.replace('<p><br></p>','');
          $('.js-text--event-detail-rte').html(cleanedEventDetailHtml);
        }


        let $pageType = $('#page-type');

        if( $pageType.length) {
          let pageType = $('#page-type').data("page-type");
          if(pageType !== "Home Page") {
            let $sideBar = $('.sfContentGadgetsPane');
            let sideBarMenuOptions = $sideBar.find('.rpText').each(function(){
              if( $(this).text() === pageType) {
                $(this).trigger('click');
              }
            })
          }

        }

        let $sideBarLayout = $('.sfWidgetsWrp');

        if( $sideBarLayout.length ){
          let $sideBarLayourOptions = $('.sfWidgetsWrp').find('.rpText');
          $sideBarLayourOptions.each(function(){
            if( $(this).text() === "Grid widgets" ) {
              $(this).trigger("click");
            }
          })
        }

        if($('.table__col-heading').length){
          $('.table__col-heading').parents('td').each(function(i,ele){
            $(this).replaceWith('<th>' + ele.innerHTML + '</th>');
          })
        }
        
        if($('.members__table-container').length){
            $('.members__table-container').each(function(i,ele){
              var $tableHeading = $(this).find('table tbody > tr:not(".rdTop"):first-child > td:first-child');

              $tableHeading.each(function(){
                console.log("table", this, this.innerHTML)
                $(this).replaceWith('<th>' + this.innerHTML + '</th>');
              })
            })
        }

    })
  }
}
